import { ReactNode } from "react";

interface PillProps {
  label: string;
  count: number;
  icon?: ReactNode;
}

const mainStyle = `
  flex w-fit px-4 py-2 space-x-3 justify-center items-center bg-bg-components-base border border-overlay rounded-full select-none group
  hover:bg-bg-components-hover
  focus:bg-bg-components-hover focus:outline-focus focus:outline-offset-0
  active:bg-bg-interactive-light active:border-bg-interactive-base
`;

const iconStyle = `
  text-icon-bg-subtle group-hover:text-icon-bg-base group-focus:text-icon-bg-base group-active:text-icon-interactive
`;

const counterStyle = `
  flex h-5 w-5 typography-small-base text-text-on-color rounded-full justify-center items-center
  bg-badge-gray-icon group-active:bg-badge-blue-icon group-active:font-bold
`;

const labelStyle = `
  typography-medium-base text-text-subtle
  group-hover:text-text-base group-focus:text-text-base
  group-active:text-text-interactive-base group-active:typography-medium-strong
`;

const Pill = ({
  label, count, icon,
}: PillProps) => (
  <button className={mainStyle} type="button">
    {icon && (
      <div id="icon" className={iconStyle}>
        {icon}
      </div>
    )}
    {label && (
      <span className={labelStyle}>
        {label}
      </span>
    )}
    <div className={counterStyle}><span>{count}</span></div>
  </button>
);

export default Pill;
